import React, {useState} from "react";
import IconButton from '@mui/material/IconButton';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import IconButtonSetting from "../../../../../../../components/Button/IconButtonSetting";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { Cardio_TableData } from "./Get_Cardio_table";


export default function Cardio_Variants() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>   

<IconButton onClick={handleOpen} size="small" >
            <IconButtonSetting />
</IconButton>

<CustomDialog open={open} onClose={handleClose}

title='Cardio Panel - Variants'

content={ <Cardio_TableData />}

/>

</>
)}